import { convert } from '../utils'

let lines = [


  {text:['拉霍亚'],startTime:'00:00:01.00', endTime:'00:00:01.20'},
  {text:['拉霍亚是圣地亚哥的周边城市之一'],startTime:'00:00:01.21', endTime:'00:00:04.18'},
  {text:['这里几乎能满足所有人的需求'],startTime:'00:00:04.19', endTime:'00:00:07.17'},
  {text:['被誉为“海岸珍宝”'],startTime:'00:00:07.18', endTime:'00:00:09.20'},
  {text:['你可以在沙滩上散步'],startTime:'00:00:09.21', endTime:'00:00:11.19'},
  {text:['看海豹和海鸟在岩石上晒太阳'],startTime:'00:00:11.20', endTime:'00:00:15.13'},
  {text:['也可以体验冲浪'],startTime:'00:00:15.14', endTime:'00:00:17.07'},
  {text:['浮潜 划艇 滑翔'],startTime:'00:00:17.08', endTime:'00:00:19.18'},
  {text:['等各种海上活动'],startTime:'00:00:19.19', endTime:'00:00:21.15'},
  {text:['尽情感受'],startTime:'00:00:21.16', endTime:'00:00:22.17'},
  {text:['拉霍亚的的热闹非凡'],startTime:'00:00:22.18', endTime:'00:00:25.01'},

]

export default convert(lines)
